<script>
  import { Link } from "svelte-routing";
  let menu = false;
  function togglemenu() {
    menu = !menu;
  }
</script>


  <button on:click={togglemenu} class="inline-block md:hidden top-2 right-2 absolute w-10 h-10 text-gray-600 p-1">
    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
  </button>
  <!-- <nav class="flex font-pixel text-xl space-between space-x-4 justify-end p-4 mr-2"> -->
  <nav
    class={`${menu ? 'pt-14' : 'hidden'} md:pt-6 mr-2 md:block flex text-right justify-end z-20 flex flex-col md:flex-row md:space-x-5 w-full font-pixel text-2xl md:w-auto p-6`}
  >
    <Link to="/" class="">Home</Link>
    <Link to="/press" class="">About</Link>
    <!-- <a href="https://rarible.com/xx__xx" target="_blank" class="">Marketplace</a> -->
    <Link to="/faq" class="">FAQ</Link>
    <Link to="/gallery" class="">Collections</Link>
  </nav>
